import { httpClient } from '@/services/http/httpClient'

export async function registerPages(currentURL: string) {
  await httpClient.post('/users/sessions/page-views', {
    currentURL,
  })
}
